export default {
  lang_name: '\u7E41\u9AD4\u4E2D\u6587',
  tab_main: '\u4E3B\u9801', tab_upgrade: '\u5347\u7D1A', tab_prestige: '\u8F49\u751F', tab_achievement: '\u6210\u5C31', tab_mission: '\u4EFB\u52D9', tab_domination: '\u5F81\u670D', tab_settings: '\u8A2D\u5B9A',
  hud_cps: '/\u79D2', hud_boost: '\u589E\u76CA',
  main_tap_area: '\u9EDE\u64CA!', main_combo: '\u9023\u64CA',
  prod_informant: '\u7DDA\u4EBA', prod_informant_desc: '\u8857\u982D\u60C5\u5831\u6536\u96C6',
  prod_hacker: '\u99ED\u5BA2', prod_hacker_desc: '\u4EBA\u985E\u7DB2\u8DEF\u6EF2\u900F',
  prod_disguiser: '\u507D\u88DD\u5C08\u5BB6', prod_disguiser_desc: '\u4EBA\u985E\u5F62\u614B\u507D\u88DD',
  prod_mindController: '\u5FC3\u9748\u63A7\u5236\u5E2B', prod_mindController_desc: '\u4EBA\u985E\u8F3F\u8AD6\u64CD\u63A7',
  prod_secretLab: '\u79D8\u5BC6\u5BE6\u9A57\u5BA4', prod_secretLab_desc: '\u722C\u87F2\u4EBA\u79D1\u6280\u7814\u7A76',
  prod_mediaCell: '\u5A92\u9AD4\u5C0F\u7D44', prod_mediaCell_desc: '\u65B0\u805E/\u793E\u7FA4\u63A5\u7BA1',
  prod_shadowGovt: '\u5F71\u5B50\u653F\u5E9C', prod_shadowGovt_desc: '\u653F\u5BA2\u66FF\u63DB\u884C\u52D5',
  prod_deepBase: '\u6DF1\u5C64\u57FA\u5730', prod_deepBase_desc: '\u5730\u4E0B\u5DE8\u578B\u57FA\u5730',
  prod_orbitalStation: '\u8ECC\u9053\u7AD9', prod_orbitalStation_desc: '\u885B\u661F\u76E3\u63A7\u7DB2',
  prod_dimensionGate: '\u7DAD\u5EA6\u4E4B\u9580', prod_dimensionGate_desc: '\u5F9E\u6BCD\u661F\u53EC\u559A\u63F4\u8ECD',
  prod_planetController: '\u884C\u661F\u63A7\u5236\u5668', prod_planetController_desc: '\u76F4\u63A5\u63A7\u5236\u5730\u7403\u7CFB\u7D71',
  prod_galacticBeacon: '\u9280\u6CB3\u4FE1\u6A19', prod_galacticBeacon_desc: '\u8207\u7E3D\u90E8\u76F4\u901A',
  prod_locked: '\u89E3\u9396\uFF1A', prod_locked_prestige: '\u8F49\u751F {n}\u6B21', prod_locked_time: '{n}\u5206\u904A\u73A9',
  milestone_squad: '\u5C0F\u968A\u7DE8\u6210', milestone_company: '\u4E2D\u968A\u5B8C\u6210', milestone_battalion: '\u5927\u968A\u6230\u529B',
  milestone_regiment: '\u806F\u968A\u6230\u529B', milestone_division: '\u5E2B\u5718\u6230\u529B', milestone_corps: '\u8ECD\u5718\u6230\u529B',
  click_basic_training: '\u57FA\u790E\u8A13\u7DF4', click_combat_training: '\u6230\u9B25\u8A13\u7DF4',
  click_psychic_awaken: '\u5FC3\u9748\u89BA\u9192', click_transform: '\u8B8A\u5F62\u5F37\u5316',
  click_telepathy: '\u5FC3\u9748\u611F\u61C9', click_critical_eye: '\u81F4\u547D\u4E4B\u773C',
  click_dimension_sense: '\u7DAD\u5EA6\u611F\u77E5', click_galaxy_field: '\u9280\u6CB3\u529B\u5834',
  click_lethal_strike: '\u5FC5\u6BBA\u4E00\u64CA', click_absolute: '\u7D55\u5C0D\u6EF2\u900F',
  click_planet_destroyer: '\u884C\u661F\u6BC0\u6EC5\u8005', click_galaxy_finger: '\u9280\u6CB3\u9738\u4E3B\u4E4B\u6307',
  special_info_network: '\u60C5\u5831\u7DB2\u7D61', special_info_network_desc: '\u7DDA\u4EBA & \u99ED\u5BA2 x2',
  special_perfect_disguise: '\u5B8C\u7F8E\u507D\u88DD', special_perfect_disguise_desc: '\u6240\u6709\u7279\u5DE5 x1.5',
  special_mass_brainwash: '\u5927\u898F\u6A21\u6D17\u8166', special_mass_brainwash_desc: '\u5FC3\u9748\u63A7\u5236 & \u5A92\u9AD4 x3',
  special_shadow_network: '\u5F71\u5B50\u7DB2\u7D61', special_shadow_network_desc: '\u96E2\u7DDA\u6536\u5165 +25%',
  special_underground_empire: '\u5730\u4E0B\u5E1D\u570B', special_underground_empire_desc: '\u6240\u6709\u7279\u5DE5 x2',
  special_orbital_surveillance: '\u8ECC\u9053\u76E3\u63A7', special_orbital_surveillance_desc: '\u9EC3\u91D1\u4E8B\u4EF6\u983B\u7387 +50%',
  special_dimension_supply: '\u7DAD\u5EA6\u88DC\u7D66\u7DDA', special_dimension_supply_desc: '\u9EDE\u64CA\u53CE\u5165 x5',
  special_galactic_alliance: '\u9280\u6CB3\u540C\u76DF', special_galactic_alliance_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x10',
  special_combo_master: '\u9023\u64CA\u5927\u5E2B', special_combo_master_desc: '\u9023\u64CA\u4E0A\u9650 x3',
  special_time_warp: '\u6642\u9593\u626D\u66F2', special_time_warp_desc: '\u96E2\u7DDA\u4E0A\u9650 12\u5C0F\u6642',
  special_agent_synergy: '\u7279\u5DE5\u5354\u540C', special_agent_synergy_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x1.5',
  special_massive_infiltration: '\u5927\u898F\u6A21\u6EF2\u900F', special_massive_infiltration_desc: '\u6BCF\u79D2 \u{1F6F8} \u53CE\u5165 x2',
  subtab_click: '\u9EDE\u64CA', subtab_special: '\u7279\u6B8A',
  prestige_title: '\u7D44\u7E54\u91CD\u7D44', prestige_total_ip: '\u7E3D\u7D2F\u{1F6F8}', prestige_gc_gain: '\u53EF\u7372\u5F97\u{1F48E}',
  prestige_gc_current: '\u76EE\u524D\u{1F48E}', prestige_execute: '\u7D44\u7E54\u91CD\u7D44',
  prestige_confirm: '\u91CD\u7F6E\u6240\u6709\u9032\u5EA6\u4EE5\u7372\u5F97 {gc} \u9280\u6CB3\u4FE1\u7528\uFF1F',
  prestige_ad_bonus: '\u770B\u5EE3\u544A +50% \u{1F48E}', prestige_requirement: '\u9700\u8981 100\u5104+ \u{1F6F8}',
  prestige2_title: '\u9280\u6CB3\u91CD\u7D44', prestige2_cores_gain: '\u53EF\u7372\u5F97\u{1F52E}',
  prestige2_cores_current: '\u76EE\u524D\u{1F52E}', prestige2_execute: '\u9280\u6CB3\u91CD\u7D44',
  prestige2_requirement: '\u9700\u8981 15+ \u8F49\u751F\u6B21\u6578 & 100+ \u{1F48E}',
  prestige2_confirm: '\u6DF1\u5EA6\u91CD\u7F6E\u4EE5\u7372\u5F97 {cores} \u9280\u6CB3\u6838\u5FC3\uFF1F',
  pup_galaxy_mult: '\u9280\u6CB3\u500D\u7387', pup_galaxy_mult_desc: '\u6BCF\u7D1ACPS x1.5\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  pup_infil_accel: '\u6EF2\u900F\u52A0\u901F', pup_infil_accel_desc: '\u8F49\u751F\u5F8C\u6BCF\u7D1A\u643A\u5E361\u5104 \u{1F6F8}\u958B\u59CB',
  pup_tap_enhance: '\u9EDE\u64CA\u5F37\u5316', pup_tap_enhance_desc: '\u6BCF\u7D1A\u9EDE\u64CA\u53CE\u5165 x2\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  pup_offline_expand: '\u96E2\u7DDA\u64F4\u5C55', pup_offline_expand_desc: '\u96E2\u7DDA\u7372\u52F5\u4E0A\u9650 +1h/Lv\uFF08\u57FA\u790E8h\uFF09',
  pup_offline_eff: '\u96E2\u7DDA\u6548\u7387', pup_offline_eff_desc: '\u96E2\u7DDA\u53CE\u76CA\u7387 +10%p/Lv\uFF08\u57FA\u790E50%\uFF09',
  pup_agent_discount: '\u7279\u5DE5\u6298\u6263', pup_agent_discount_desc: '\u6BCF\u7D1A\u7279\u5DE5\u51C6\u5100\u8CBB\u7528 -10%\uFF08\u6700\u9AD8 -50%\uFF09',
  pup_auto_click: '\u81EA\u52D5\u9EDE\u64CA', pup_auto_click_desc: '\u6BCF\u7D1A\u6BCF\u79D2\u81EA\u52D5\u9EDE\u64CA3\u6B21\uFF08\u6700\u969315\u6B21/\u79D2\uFF09',
  pup_golden_luck: '\u9EC3\u91D1\u904B\u6C23', pup_golden_luck_desc: '\u9EC3\u91D1\u4E8B\u4EF6\u734E\u52F5 +20%/Lv\uFF08\u6700\u9AD8 +200%\uFF09',
  pup_combo_keep: '\u9023\u64CA\u4FDD\u6301', pup_combo_keep_desc: '\u9023\u64CA\u6301\u7E8C\u6642\u9593 +0.5\u79D2/Lv\uFF08\u57FA\u790E2\u79D2\uFF09',
  pup_quick_start: '\u5FEB\u901F\u958B\u59CB', pup_quick_start_desc: '\u8F49\u751F\u5F8C\u81EA\u52D5\u7372\u5F97\u524D5\u7A2E\u7279\u5DE5\u54041\u540D',
  p2up_galaxy_speed: '\u9280\u6CB3\u52A0\u901F', p2up_galaxy_speed_desc: '\u6BCF\u7D1A\u8F49\u751F\u6642\u{1F48E}\u7372\u53D6\u91CF x2\uFF08\u758A\u52A0\u500D\u589E\uFF09',
  p2up_auto_prestige: '\u81EA\u52D5\u8F49\u751F', p2up_auto_prestige_desc: '\u9054\u5230100\u5104 \u{1F6F8}\u6642\u81EA\u52D5\u8F49\u751F',
  p2up_permanent: '\u6C38\u4E45\u7279\u5DE5', p2up_permanent_desc: '\u8F49\u751F\u5F8C\u4FDD\u7559\u524D3\u7A2E\u521D\u59CB\u7279\u5DE5',
  p2up_dimension_accel: '\u7DAD\u5EA6\u52A0\u901F', p2up_dimension_accel_desc: '\u6BCF\u7D1ACPS x5\uFF08\u758A\u52A0\uFF0C\u6C38\u4E45\uFF09',
  p2up_galaxy_memory: '\u9280\u6CB3\u8A18\u61B6', p2up_galaxy_memory_desc: '\u8F49\u751F\u6642\u4FDD\u75593\u500B\u6D3B\u8E8D\u5A41\u76CA',
  p2up_spacetime: '\u6642\u7A7A\u626D\u66F2', p2up_spacetime_desc: '\u96E2\u7DDA\u53CE\u76CA\u7387\u63D0\u5347\u81F3100%\uFF08\u6C38\u4E45\uFF09',
  p2up_automate: '\u9280\u6CB3\u81EA\u52D5\u5316', p2up_automate_desc: '\u81EA\u52D5\u51C6\u5100\u7279\u5DE5\uFF08\u6C38\u4E45\uFF09',
  rank_e: '\u5BE6\u7FD2\u751F', rank_d: '\u521D\u7D1A\u7279\u5DE5', rank_c: '\u7279\u5DE5', rank_b: '\u8CC7\u6DF1\u7279\u5DE5',
  rank_a: '\u5E79\u90E8', rank_s: '\u5C40\u9577', rank_ss: '\u6700\u9AD8\u6307\u63EE\u5B98', rank_sss: '\u9280\u6CB3\u9738\u4E3B',
  ach_title: '\u6210\u5C31', ach_filter_all: '\u5168\u90E8', ach_filter_tap: '\u9EDE\u64CA', ach_filter_resource: '\u8CC7\u6E90',
  ach_filter_producer: '\u751F\u7522\u8005', ach_filter_prestige: '\u8F49\u751F', ach_filter_time: '\u6642\u9593',
  ach_filter_special: '\u7279\u6B8A', ach_filter_ad: '\u6587\u4EF6', ach_filter_combo: '\u9023\u64CA',
  ach_t01: '\u7B2C\u4E00\u6B65', ach_t01_reward: '+1 \u9EDE\u64CA\u529B', ach_t02: '\u6696\u8EAB', ach_t02_reward: '+5% \u9EDE\u64CA\u529B',
  ach_t03: '\u7A69\u5B9A\u7279\u5DE5', ach_t03_reward: '+10% \u9EDE\u64CA\u529B', ach_t04: '\u89F8\u63A7\u5927\u5E2B', ach_t04_reward: '+15% \u9EDE\u64CA\u529B',
  ach_t05: '\u722C\u87F2\u4EBA\u6BC5\u529B', ach_t05_reward: '+20% \u9EDE\u64CA\u529B', ach_t06: '\u9280\u6CB3\u4E4B\u6307', ach_t06_reward: '+25% \u9EDE\u64CA\u529B',
  ach_t07: '\u9023\u64CA\u5B78\u5F92', ach_t07_reward: '+0.5\u79D2 \u9023\u64CA', ach_t08: '\u9023\u64CA\u5927\u5E2B', ach_t08_reward: '+0.5 \u9023\u64CA\u4E0A\u9650',
  ach_r01: '\u5C0F\u9053\u6D88\u606F', ach_r01_reward: '+5% 每秒\u{1F6F8}', ach_r02: '\u60C5\u5831\u6536\u96C6\u8005', ach_r02_reward: '+5% 每秒\u{1F6F8}',
  ach_r03: '\u6A5F\u5BC6\u5EAB', ach_r03_reward: '+5% 每秒\u{1F6F8}', ach_r04: '\u767E\u842C\u6EF2\u900F', ach_r04_reward: '+10% 每秒\u{1F6F8}',
  ach_r05: '\u5104\u5143\u7279\u5DE5', ach_r05_reward: '+10% 每秒\u{1F6F8}', ach_r06: '\u5146\u5143\u884C\u52D5', ach_r06_reward: '+15% 每秒\u{1F6F8}',
  ach_r07: '\u4EAC\u5143\u5E1D\u570B', ach_r07_reward: '+15% 每秒\u{1F6F8}', ach_r08: '\u9280\u6CB3\u6D77\u6D0B', ach_r08_reward: '+20% 每秒\u{1F6F8}',
  ach_r09: '\u5B87\u5B99\u5F7C\u7AEF', ach_r09_reward: '+20% 每秒\u{1F6F8}', ach_r10: '\u7121\u9650\u6EF2\u900F', ach_r10_reward: '+30% 每秒\u{1F6F8}',
  ach_g01: '\u9996\u4F4D\u52DF\u54E1', ach_g01_reward: '\u7DDA\u4EBA x1.5', ach_g02: '\u60C5\u5831\u7DB2\u7D61', ach_g02_reward: '\u7DDA\u4EBA x2',
  ach_g03: '\u99ED\u5165\u958B\u59CB', ach_g03_reward: '\u99ED\u5BA2 x2', ach_g04: '\u7DB2\u8DEF\u8ECD\u5718', ach_g04_reward: '\u99ED\u5BA2 x3',
  ach_g05: '\u507D\u88DD\u9054\u4EBA', ach_g05_reward: '\u507D\u88DD\u5C08\u5BB6 x2', ach_g06: '\u6D17\u8166\u7DB2\u7D61', ach_g06_reward: '\u5FC3\u9748\u63A7\u5236\u5E2B x2',
  ach_g07: '\u760B\u72C2\u79D1\u5B78', ach_g07_reward: '\u79D8\u5BC6\u5BE6\u9A57\u5BA4 x2', ach_g08: '\u5A92\u9AD4\u638C\u63A7', ach_g08_reward: '\u5A92\u9AD4\u5C0F\u7D44 x2',
  ach_g09: '\u5F71\u5B50\u5167\u95A3', ach_g09_reward: '\u5F71\u5B50\u653F\u5E9C x2', ach_g10: '\u5730\u4E0B\u5E1D\u570B', ach_g10_reward: '\u6DF1\u5C64\u57FA\u5730 x2',
  ach_g11: '\u8ECC\u9053\u7D71\u6CBB', ach_g11_reward: '\u8ECC\u9053\u7AD9 x2', ach_g12: '\u9280\u6CB3\u4E4B\u4E3B', ach_g12_reward: '全體 每秒\u{1F6F8} x2',
  ach_p01: '\u9996\u6B21\u91CD\u7D44', ach_p01_reward: '+5 \u{1F48E} \u734E\u52F5', ach_p02: '\u5FAA\u74B0\u4E4B\u5473', ach_p02_reward: '+10% \u{1F48E}',
  ach_p03: '\u8001\u7DF4\u7279\u5DE5', ach_p03_reward: '+10% \u{1F48E}', ach_p04: '\u8F49\u751F\u4E0A\u7665', ach_p04_reward: '+15% \u{1F48E}',
  ach_p05: '\u7121\u9650\u8FF4\u5708', ach_p05_reward: '+20% \u{1F48E}', ach_p06: '\u9280\u6CB3\u8A18\u61B6', ach_p06_reward: '+25% \u{1F48E}',
  ach_p07: '\u9280\u6CB3\u91CD\u7D44', ach_p07_reward: '+3 \u{1F52E}\u734E\u52F5', ach_p08: '\u7DAD\u5EA6\u4E4B\u4E3B', ach_p08_reward: '+20% \u{1F52E}',
  ach_h01: '\u65B0\u4EBA\u5831\u5230', ach_h01_reward: '\u6B61\u8FCE\u734E\u52F5 100 \u{1F6F8}', ach_h02: '1\u5C0F\u6642\u73ED', ach_h02_reward: '+5% 每秒\u{1F6F8}',
  ach_h03: '\u534A\u5929', ach_h03_reward: '+10% 每秒\u{1F6F8}', ach_h04: '24\u5C0F\u6642\u76E3\u8996', ach_h04_reward: '\u96E2\u7DDA +2\u5C0F\u6642',
  ach_h05: '3\u5929\u4EFB\u52D9', ach_h05_reward: '每秒\u{1F6F8} x1.5', ach_h06: '\u9031\u6EF2\u900F', ach_h06_reward: '每秒\u{1F6F8} x2',
  ach_s01: '\u53EF\u7591\u4EBA\u985E', ach_s01_reward: '1 \u6587\u4EF6', ach_s02: '\u4E7E\u6DE8\u958B\u59CB', ach_s02_reward: '\u7A31\u865F\uFF1A\u9B6F\u8393\u7279\u5DE5',
  ach_s03: '\u5168\u90E8\u6295\u5165', ach_s03_reward: '+10% 每秒\u{1F6F8}', ach_s04: '\u901F\u901A', ach_s04_reward: '+10 \u{1F48E} \u734E\u52F5',
  ach_s05: '\u9EC3\u91D1\u7375\u4EBA', ach_s05_reward: '\u4E8B\u4EF6\u983B\u7387 -20%', ach_s06: '\u591C\u884C\u7279\u5DE5', ach_s06_reward: '夜間 每秒\u{1F6F8} x1.5',
  ach_s07: 'F2P\u6230\u58EB', ach_s07_reward: '\u5EE3\u544A\u734E\u52F5 +30%', ach_s08: '\u6536\u85CF\u5BB6', ach_s08_reward: '每秒\u{1F6F8} x3',
  ach_a01: '\u5EE3\u544A\u65B0\u624B', ach_a01_reward: '1 \u6587\u4EF6', ach_a02: '\u5EE3\u544A\u611B\u597D\u8005', ach_a02_reward: '2 \u6587\u4EF6',
  ach_a03: '\u5EE3\u544A\u5927\u5E2B', ach_a03_reward: '\u5EE3\u544A\u734E\u52F5 +30%', ach_a04: '\u6587\u4EF6\u6536\u96C6\u8005', ach_a04_reward: '\u6587\u4EF6\u6548\u679C +20%',
  ach_a05: '\u6587\u4EF6\u5C08\u5BB6', ach_a05_reward: '\u6587\u4EF6\u6548\u679C +50%',
  ach_c01: '\u9023\u64CA\u958B\u59CB', ach_c01_reward: '+0.3\u79D2 \u9023\u64CA', ach_c02: '\u7BC0\u594F\u611F', ach_c02_reward: '+0.1 \u9023\u64CA\u500D\u7387',
  ach_c03: '\u9EC3\u91D1\u65B0\u624B', ach_c03_reward: '\u4E8B\u4EF6\u734E\u52F5 +10%', ach_c04: '\u9EC3\u91D1\u6536\u96C6\u8005', ach_c04_reward: '\u4E8B\u4EF6\u983B\u7387 -10%',
  ach_c05: '\u65E5\u5E38\u72C2\u71B1', ach_c05_reward: '\u4EFB\u52D9\u734E\u52F5 +50%',
  golden_intel_leak: '\u60C5\u5831\u6D29\u6F0F!', golden_agent_frenzy: '\u7279\u5DE5\u72C2\u6F6E!', golden_money_launder: '\u8CC7\u91D1\u6E05\u6D17!',
  golden_facility_boost: '\u8A2D\u65BD\u8D85\u8F09!', golden_supply_drop: '\u9280\u6CB3\u88DC\u7D66!', golden_touch: '\u9EDE\u64CA!',
  golden_ad_double: '\u770B\u5EE3\u544A\u7372\u5F97 2\u500D',
  offline_title: '\u96E2\u7DDA\u5831\u544A', offline_elapsed: '\u7D93\u904E\u6642\u9593', offline_earned: '\u7372\u5F97 \u{1F6F8}',
  offline_cap: '\u6700\u9AD8 {h}\u5C0F\u6642\u9069\u7528', offline_claim: '\u9818\u53D6', offline_double: '\u770B\u5EE3\u544A\u7372\u5F97 2\u500D ({amount})',
  offline_hours: '{h}\u5C0F\u6642 {m}\u5206',
  settings_title: '\u8A2D\u5B9A', settings_bgm: 'BGM', settings_sfx: '\u97F3\u6548', settings_lang: '\u8A9E\u8A00',
  settings_reset: '\u91CD\u7F6E\u904A\u6232', settings_reset_confirm: '\u522A\u9664\u6240\u6709\u9032\u5EA6\u91CD\u65B0\u958B\u59CB\uFF1F',
  settings_stats: '\u7D71\u8A08', settings_total_ip: '\u7E3D\u7372\u5F97 \u{1F6F8}', settings_total_taps: '\u7E3D\u9EDE\u64CA\u6578',
  settings_total_prestiges: '\u7E3D\u8F49\u751F\u6578', settings_play_time: '\u7E3D\u904A\u73A9\u6642\u9593', settings_docs_shop: '\u6A5F\u5BC6\u6587\u4EF6\u5546\u5E97',
  doc_shop_title: '\u6A5F\u5BC6\u6587\u4EF6\u5546\u5E97',
  doc_ip_boost: '自動收益加速', doc_ip_boost_desc: '30秒內每秒🛸產量2倍',
  doc_mega_tap: '強化點擊訓練', doc_mega_tap_desc: '30秒內點擊收益3倍',
  doc_auto_click: '自動滲透裝置', doc_auto_click_desc: '30秒內每秒自動點擊10次',
  doc_instant_golden: '緊急黃金召喚', doc_instant_golden_desc: '立即觸發黃金事件',
  doc_timeskip: '時間加速器', doc_timeskip_desc: '立即獲得2小時🛸收益',
  doc_prestige_boost: '銀河增幅器', doc_prestige_boost_desc: '下次重生時💎獲取量2倍',
  doc_prestige_boost_active: '下次重生時💎x2 待機中', doc_prestige_boost_active_badge: '✅ 待機中',
  ad_offline_double: '\u96E2\u7DDA\u734E\u52F5\u52A0\u500D', ad_cps_boost: '\u6BCF\u79D2\u6536\u5165 x10 \u589E\u76CA (15\u79D2)',
  ad_prestige_bonus: '\u8F49\u751F \u{1F48E} +50%', ad_timeskip: '\u6642\u9593\u8DF3\u8E8D (2\u5C0F\u6642)', ad_free_docs: '\u514D\u8CBB\u6587\u4EF6',
  ad_golden_double: '\u9EC3\u91D1\u734E\u52F5\u52A0\u500D', ad_start_boost: '\u65B0\u624B\u589E\u76CA\u5305',
  ad_watching: '\u5EE3\u544A\u8F09\u5165\u4E2D...', ad_cooldown: '{t} \u5F8C\u53EF\u7528',
  settings_sfx_test: '\u6E2C\u8A66\u97F3\u6548', settings_sound_reset: '\u91CD\u7F6E', settings_sound_reset_done: '\u97F3\u6548\u5DF2\u91CD\u7F6E',
  num_k: '\u842C', num_m: '\u5104', num_b: '\u5146', num_t: '\u4EAC', num_qa: '\u5793',
  num_qi: '\u25CB', num_sx: '\u79ED', num_sp: '\u7A63', num_oc: '\u6E9D', num_no: '\u6B63', num_dc: '\u8F09',
  mission_title: '\u6BCF\u65E5\u4EFB\u52D9',
  mission_claim: '\u9818\u53D6',
  mission_all_complete: '\u5168\u90E8\u5B8C\u6210\u734E\u52F5\uFF01',
  mission_clear_label: '\u4EFB\u52D9',
  mission_all_clear_label: '\u5168\u90E8\u5B8C\u6210',
  ach_unlock_label: '\u6210\u5C31',
  mission_diff_easy: '\u7C21\u55AE',
  mission_diff_normal: '\u666E\u901A',
  mission_diff_hard: '\u56F0\u96E3',
  mission_tap_100: '\u8F15\u8F15\u9EDE\u64CA',
  mission_tap_100_desc: '\u9EDE\u64CA 100 \u6B21',
  mission_tap_300: '\u6696\u624B\u904B\u52D5',
  mission_tap_300_desc: '\u9EDE\u64CA 300 \u6B21',
  mission_buy_5: '\u5C0F\u578B\u62DB\u52DF',
  mission_buy_5_desc: '\u8CFC\u8CB7 5 \u500B\u751F\u7522\u8005',
  mission_combo_10: '\u9023\u64CA\u5165\u9580',
  mission_combo_10_desc: '\u9054\u5230 10 \u9023\u64CA',
  mission_golden_1: '\u5E78\u904B\u6355\u7372',
  mission_golden_1_desc: '\u6355\u6349 1 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_tap_1000: '\u91CD\u64CA\u624B',
  mission_tap_1000_desc: '\u9EDE\u64CA 1,000 \u6B21',
  mission_buy_20: '\u5C0F\u968A\u5EFA\u9020\u8005',
  mission_buy_20_desc: '\u8CFC\u8CB7 20 \u500B\u751F\u7522\u8005',
  mission_combo_50: '\u9023\u64CA\u9054\u4EBA',
  mission_combo_50_desc: '\u9054\u5230 50 \u9023\u64CA',
  mission_golden_3: '\u6DD8\u91D1\u71B1',
  mission_golden_3_desc: '\u6355\u6349 3 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_earn_1m: '\u767E\u842C\u884C\u52D5',
  mission_earn_1m_desc: '\u8CFA\u53D6 1M \u{1F6F8}',
  mission_tap_5000: '\u9EDE\u64CA\u6A5F\u5668',
  mission_tap_5000_desc: '\u9EDE\u64CA 5,000 \u6B21',
  mission_buy_50: '\u8ECD\u968A\u5EFA\u9020\u8005',
  mission_buy_50_desc: '\u8CFC\u8CB7 50 \u500B\u751F\u7522\u8005',
  mission_combo_100: '\u9023\u64CA\u4E4B\u795E',
  mission_combo_100_desc: '\u9054\u5230 100 \u9023\u64CA',
  mission_golden_5: '\u9EC3\u91D1\u5927\u5E2B',
  mission_golden_5_desc: '\u6355\u6349 5 \u500B\u9EC3\u91D1\u4E8B\u4EF6',
  mission_earn_1b: '\u5104\u5143\u7279\u5DE5',
  mission_earn_1b_desc: '\u8CFA\u53D6 1B \u{1F6F8}',
  mission_tap_200: '快手',
  mission_tap_200_desc: '點擊200次',
  mission_buy_3: '首批招募',
  mission_buy_3_desc: '購買3個生產者',
  mission_combo_15: '連擊入門',
  mission_combo_15_desc: '達成15連擊',
  mission_earn_10k: '零用錢',
  mission_earn_10k_desc: '賺取10K 🛸',
  mission_earn_100k: '募資者',
  mission_earn_100k_desc: '賺取100K 🛸',
  mission_tap_500: '穩定點擊',
  mission_tap_500_desc: '點擊500次',
  mission_tap_700: '不屈不撓',
  mission_tap_700_desc: '點擊700次',
  mission_buy_10: '隊長',
  mission_buy_10_desc: '購買10個生產者',
  mission_combo_30: '連擊鏈',
  mission_combo_30_desc: '達成30連擊',
  mission_golden_2: '雙倍黃金',
  mission_golden_2_desc: '觸碰2次黃金事件',
  mission_tap_3000: '點擊戰士',
  mission_tap_3000_desc: '點擊3,000次',
  mission_buy_30: '大隊',
  mission_buy_30_desc: '購買30個生產者',
  mission_combo_75: '連擊精英',
  mission_combo_75_desc: '達成75連擊',
  mission_golden_4: '黃金獵人',
  mission_golden_4_desc: '觸碰4次黃金事件',
  mission_earn_10m: '大亨',
  mission_earn_10m_desc: '賺取10M 🛸',

  // Conquest
  cq_title: '\u4E16\u754C\u5F81\u670D',
  cq_progress: '\u5DF2\u5F81\u670D',
  cq_infiltration_power: '滲透力',
  cq_active_conquest: '滲透中',
  cq_infiltration_progress: '滲透進度',
  cq_time_remaining: '預估完成時間',
  cq_start_infiltration: '開始滲透',
  cq_stop_infiltration: '停止滲透',
  cq_no_power_hint: '雇用特工來產生滲透力',
  cq_locked: '\u9396\u5B9A',
  cq_available: '\u53EF\u5165\u4FB5',
  cq_conquered: '\u5DF2\u5F81\u670D',
  cq_popup_title: '征服完成！',
  cq_popup_desc: '已被征服！建造設施以變得更強大。',
  cq_back: '\u8FD4\u56DE',
  cq_invest_title: '\u6295\u8CC7\u{1F6F8}\u9032\u884C\u5F81\u670D',
  cq_current_ip: '\u7576\u524D\u{1F6F8}',
  cq_facilities: '\u8A2D\u65BD',
  cq_build: '\u5EFA\u9020',
  cq_upgrade: '\u5347\u7D1A',
  cq_next_level: '\u4E0B\u4E00\u7D1A',
  cq_counter_intel_title: '\u53CD\u9593\u8ADE\u8B66\u5831\uFF01',
  cq_counter_intel_text: '\u60A8\u5728{country}\u7684\u6EF2\u900F\u5DF2\u88AB\u767C\u73FE\uFF01\u9032\u5EA6\u5C07\u6703\u6E1B\u5C11\u3002',
  cq_defend_ad: '\u770B\u5EE3\u544A\u9632\u79A6',
  cq_accept_loss: '\u63A5\u53D7\u640D\u5931',
  cq_ending_title: '\u5730\u7403\u5F81\u670D\u5B8C\u6210\uFF01',
  cq_ending_text: '\u722C\u87F2\u4EBA\u9670\u8B00\u5DF2\u5B8C\u6210\u3002\u6240\u6709\u570B\u5BB6\u90FD\u5411\u6697\u5F71\u5E1D\u570B\u81E3\u670D\u3002',
  cq_ending_time: '\u904A\u6232\u6642\u9593',
  cq_ending_prestiges: '\u8F49\u751F\u6B21\u6578',
  cq_ending_total_ip: '\u7E3D\u{1F6F8}',
  cq_ending_taps: '\u7E3D\u9EDE\u64CA\u6578',
  cq_ending_continue: '\u7E7C\u7E8C\u904A\u6232',
  cq_egypt: '\u57C3\u53CA', cq_egypt_desc: '\u91D1\u5B57\u5854\u53E4\u4EE3\u57FA\u5730',
  cq_brazil: '\u5DF4\u897F', cq_brazil_desc: '\u4E9E\u99AC\u905C\u53E2\u6797\u85CF\u8EAB\u8655',
  cq_india: '\u5370\u5EA6', cq_india_desc: '\u90A3\u8FE6\u4FE1\u4EF0\u6EF2\u900F',
  cq_australia: '\u6FB3\u6D32', cq_australia_desc: '\u6C99\u6F20\u5730\u4E0B\u789E\u5821',
  cq_japan: '\u65E5\u672C', cq_japan_desc: '\u6280\u8853\u7ACA\u53D6\u884C\u52D5',
  cq_korea: '\u97D3\u570B', cq_korea_desc: 'NIS\u7DB2\u8DEF\u9632\u79A6\u7A81\u7834',
  cq_uk: '\u82F1\u570B', cq_uk_desc: 'MI5/MI6\u7687\u5BA4\u6EF2\u900F',
  cq_russia: '\u4FC4\u7F85\u65AF', cq_russia_desc: 'FSB\u897F\u4F2F\u5229\u4E9E\u884C\u52D5',
  cq_china: '\u4E2D\u570B', cq_china_desc: '\u4E16\u754C\u6700\u5F37\u76E3\u63A7\u7DB2',
  cq_usa: '\u7F8E\u570B', cq_usa_desc: 'CIA/NSA\u6700\u7D42Boss',
  fac_pyramid_vault: '\u91D1\u5B57\u5854\u91D1\u5EAB', fac_pyramid_vault_d: '每級 每秒\u{1F6F8} +5%',
  fac_nile_network: '\u5C3C\u7F85\u6CB3\u7DB2\u8DEF', fac_nile_network_d: '\u6BCF\u7D1A\u96E2\u7DDA +5%',
  fac_ancient_lab: '\u53E4\u4EE3\u5BE6\u9A57\u5BA4', fac_ancient_lab_d: '\u6BCF\u7D1ATAP +10%',
  fac_amazon_hideout: '\u4E9E\u99AC\u905C\u85CF\u8EAB\u8655', fac_amazon_hideout_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +2%',
  fac_samba_broadcast: '\u68EE\u5DF4\u5EE3\u64AD\u7AD9', fac_samba_broadcast_d: '每級 每秒\u{1F6F8} +8%',
  fac_jungle_lab: '\u53E2\u6797\u5BE6\u9A57\u5BA4', fac_jungle_lab_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +5%',
  fac_naga_temple: '\u90A3\u8FE6\u795E\u6BBF', fac_naga_temple_d: '\u6BCF\u7D1A\u{1F48E} +5%',
  fac_bollywood_studio: '\u5BF6\u840A\u5862\u5DE5\u4F5C\u5BA4', fac_bollywood_studio_d: '\u6BCF\u7D1A\u96E2\u7DDA +8%',
  fac_caste_network: '\u7A2E\u59D3\u7DB2\u8DEF', fac_caste_network_d: '每級 每秒\u{1F6F8} +12%',
  fac_desert_bunker: '\u6C99\u6F20\u789E\u5821', fac_desert_bunker_d: '\u6BCF\u7D1ATAP +15%',
  fac_ayers_signal: '\u827E\u723E\u65AF\u4FE1\u865F', fac_ayers_signal_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +8%',
  fac_outback_base: '\u5167\u9678\u57FA\u5730', fac_outback_base_d: '每級 每秒\u{1F6F8} +15%',
  fac_akiba_ai: '\u79CB\u8449\u539FAI', fac_akiba_ai_d: '每級 每秒\u{1F6F8} +20%',
  fac_ninja_intel: '\u5FCD\u8005\u60C5\u5831\u90E8', fac_ninja_intel_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +3%',
  fac_tokyo_tower: '\u6771\u4EAC\u9435\u5854', fac_tokyo_tower_d: '\u6BCF\u7D1A\u{1F48E} +8%',
  fac_gangnam_hq: '\u6C5F\u5357\u7E3D\u90E8', fac_gangnam_hq_d: '每級 每秒\u{1F6F8} +25%',
  fac_cyber_command: '\u7DB2\u8DEF\u53F8\u4EE4\u90E8', fac_cyber_command_d: '\u6BCF\u7D1ATAP +25%',
  fac_kpop_brainwash: 'K-Pop\u6D17\u8166\u6A5F', fac_kpop_brainwash_d: '\u6BCF\u7D1A\u{1F48E} +10%',
  fac_royal_infiltrate: '\u7687\u5BA4\u6EF2\u900F', fac_royal_infiltrate_d: '每級 每秒\u{1F6F8} +30%',
  fac_london_tower: '\u502B\u6566\u5854', fac_london_tower_d: '\u6BCF\u7D1A\u96E2\u7DDA +15%',
  fac_mi6_double: 'MI6\u96D9\u9762\u9593\u8ADE', fac_mi6_double_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +12%',
  fac_siberia_base: '\u897F\u4F2F\u5229\u4E9E\u57FA\u5730', fac_siberia_base_d: '每級 每秒\u{1F6F8} +40%',
  fac_kgb_remnant: 'KGB\u6B98\u9EE8', fac_kgb_remnant_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +5%',
  fac_nuke_bunker: '\u6838\u5F48\u789E\u5821', fac_nuke_bunker_d: '\u6BCF\u7D1ATAP +40%',
  fac_great_wall: '\u9632\u706B\u9577\u57CE', fac_great_wall_d: '每級 每秒\u{1F6F8} +50%',
  fac_shenzhen_factory: '\u6DF1\u5733\u5DE5\u5EE0', fac_shenzhen_factory_d: '\u6BCF\u7D1A\u751F\u7522\u8005\u6298\u6263 +8%',
  fac_panda_spy: '\u718A\u8C93\u9593\u8ADE\u7DB2', fac_panda_spy_d: '\u6BCF\u7D1A\u9EC3\u91D1\u4E8B\u4EF6 +20%',
  fac_area51: '51\u5340', fac_area51_d: '每級 每秒\u{1F6F8} +80%',
  fac_pentagon: '\u4E94\u89D2\u5927\u5EC8', fac_pentagon_d: '\u6BCF\u7D1ATAP +80%',
  fac_wall_street: '\u83EF\u723E\u8857', fac_wall_street_d: '\u6BCF\u7D1A\u{1F48E} +25%',

  buy: '\u8CFC\u8CB7', max: '\u6700\u5927', level: 'Lv.', locked: '\u9396\u5B9A', unlocked: '\u89E3\u9396',
  upgrade_locked_prev: '\u8ACB\u5148\u5B78\u7FD2\u524D\u4E00\u500B\u5347\u7D1A',
  condition: '\u689D\u4EF6', cost: '\u8CBB\u7528', owned: '\u64C1\u6709', effect: '\u6548\u679C', reward: '\u734E\u52F5',
  close: '\u95DC\u9589', confirm: '\u78BA\u8A8D', cancel: '\u53D6\u6D88',

  // Conquest achievements
  ach_filter_conquest: '征服',
  ach_q01: '首次征服', ach_q01_reward: '每秒\u{1F6F8} +10%',
  ach_q02: '三國征服', ach_q02_reward: 'TAP +10%',
  ach_q03: '半壁江山', ach_q03_reward: '💎獲取 +15%',
  ach_q04: '七面旗幟', ach_q04_reward: '離線效率 +20%',
  ach_q05: '世界征服者', ach_q05_reward: '全體 每秒\u{1F6F8} x3',
  ach_q06: '設施大師', ach_q06_reward: '全體 每秒\u{1F6F8} x2',
  milestone_next: '下一個',
  settings_conquest: '征服進度',

  // Currency info
  currency_ip_name: '滲透點數 (IP)',
  currency_ip_earn: '點擊、特工自動生產、離線收入和廣告獎勵',
  currency_ip_use: '僱用特工、購買升級、投資國家征服',
  currency_gc_name: '銀河信用 (GC)',
  currency_gc_earn: '重生（組織重組）時根據累計IP獲得',
  currency_gc_use: '購買重生升級（生產倍率、離線效率等）',
  currency_cores_name: '銀河核心',
  currency_cores_earn: '二次重生（銀河重組）時根據累計GC獲得',
  currency_cores_use: '購買二次重生升級（永久增益、自動化等）',
  currency_docs_name: '機密文件',
  currency_docs_earn: '完成每日任務、觀看廣告或解鎖成就',
  currency_docs_use: '在文件商店（任務標籤）購買強力增益道具',
  currency_how_earn: '獲取方式',
  currency_how_use: '使用方式',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: '滲透精通',
  pup_infiltration_mastery_desc: '每級全體滲透力 +50%（最高 +500%）',
  pup_agent_network: '特工網路',
  pup_agent_network_desc: '每級每100名特工滲透力 +5%',
  pup_quick_infiltration: '連鎖滲透',
  pup_quick_infiltration_desc: '征服國家時下個國家進度 +10%/Lv',
  pup_critical_chance: '致命一擊訓練',
  pup_critical_chance_desc: '點擊暴擊率 +3%/Lv（基礎10%，上限50%）',
  pup_critical_damage: '致命一擊強化',
  pup_critical_damage_desc: '暴擊傷害 +1x/Lv（基礎 x3）',

  // Special upgrades - conquest
  special_spy_master: '間諜大師',
  special_spy_master_desc: '全體滲透力 x2',

  ad_income_x5: '獲得30分鐘收入',
  ad_income_x5_desc: '觀看廣告即可立即獲得\n{amount} 🛸（30分鐘的收入）！',
  ad_tap_x10: '點擊 x10 (10秒)',
  ad_tap_x10_desc: '觀看廣告後\n10秒內點擊收入提升10倍！',
  ad_free_docs_desc: '觀看廣告即可\n免費獲得1份機密文件 📜！',
  ad_prestige_desc: '觀看廣告後\n15秒內收入提升10倍！',
  cq_tutorial_title: '🌍 世界征服指南',
  cq_tutorial_text: '征服國家後可以建造<b>設施</b>！\n升級設施可獲得永久加成\n如<b>每秒收入、點擊收入、離線收入</b>等。\n\n雇用探員可提升滲透力。',
  rank_promote: '晉升',
  rank_promoted: '晉升完成！',
} as const;
